<app-mock-mobile-template [templateHtml]="data.marketingText"></app-mock-mobile-template>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Close</button>
</mat-dialog-actions>
